import { footerAbout, footerCols } from "@/mocks/homeContent";

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-twitter-x-line", label: "X" },
  { icon: "ri-telegram-line", label: "Telegram" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="leading-none">
                <span className="font-heading block text-2xl tracking-wide text-background-50">
                  <span className="text-accent-400">51</span>
                  嘿料
                </span>
                <span className="mt-0.5 block text-[10px] tracking-[0.3em] text-background-300">NEGATIVE HUB · 总集站</span>
              </span>
            </a>
            <p className="mt-4 text-xs leading-relaxed text-background-300">{footerAbout}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-800 text-background-200 transition-colors hover:bg-accent-600 hover:text-foreground-950"
                >
                  <i className={`${s.icon} text-base`} aria-hidden="true"></i>
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-3 lg:col-span-3">
            {footerCols.map((col) => (
              <div key={col.title}>
                <h3 className="text-sm font-bold text-background-50">{col.title}</h3>
                <ul className="mt-3 space-y-2">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a href="#top" className="text-xs text-background-300 transition-colors hover:text-accent-300">
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-800 bg-background-950">
        <div className="mx-auto flex w-full max-w-shell flex-col items-center justify-between gap-3 px-4 py-4 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 51嘿料 · 51嘿料负面合集 / 黑料汇总内容总集站</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href="#top" className="hover:text-background-100">用户协议</a>
            <a href="#top" className="hover:text-background-100">隐私说明</a>
            <a href="#top" className="hover:text-background-100">收录与纠错</a>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="flex items-center gap-1 text-accent-300 hover:text-accent-200"
            >
              回到顶部
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}